import React, { useState } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { useDispatch } from 'react-redux';
import { submitMockTest } from '../../../../actions/mock-test';
import KatexViewer from '@/helpers/Katex';

//ranking question template
const TemplateRankingText = ({ question, model, section }) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState(question?.answer);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    const rankingData = {
      section,
      model,
      question: question.id,
      answer: options[oldIndex].id,
      order: newIndex + 1,
    };
    dispatch(submitMockTest(rankingData));
    setOptions(arrayMove(options, oldIndex, newIndex));
  };

  const SortableItem = ({ value, sortIndex }) => (
    <li className="list-type-none" key={sortIndex}>
      <div className="form-check pb-1" key={sortIndex}>
        <label className="form-check-label custom-label">
          <div className="ranking-cards">
            {question?.has_expression ? (
              <KatexViewer text={value?.text} />
            ) : (
              value.text
            )}
          </div>
        </label>
      </div>
    </li>
  );
  const SortableList = ({ options }) => {
    return (
      <ul>
        {options?.length !== 0 &&
          options.map((value, index) => (
            <SortableItem
              // key={`item-${index}`}
              // index={index}
              value={value}
              sortIndex={index}
            />
          ))}
      </ul>
    );
  };
  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          <div className="number" id={`q-${question.q_no}`}>
            {question.q_no}
          </div>
        </div>
      </div>
      <div className="type_blank">
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>
        <SortableList
          options={options}
          // onSortEnd={onSortEnd}
        />
      </div>
    </div>
  );
};
export default TemplateRankingText;